/* eslint-disable eqeqeq */
import React from 'react';
import ReactDOM from 'react-dom';
import Menu from './components_android/MenuAndroid'
import Navbar from './components_android/NavbarAndroid'
import './css_android/style_android.css';

import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

import { getUrlParameter } from './pages_android/custom_views/utils_android/UrlHelperAndroid';
import { getRequestParams, getRequestUrl, getToken, setCookieData, setToken, getEmail} from './pages_android/custom_views/utils_android/CookieHelper'
import Loader from './pages_android/custom_views/utils_android/LoaderAndroid';
import Orders from './pages_android/Orders';
import Auth from './pages_android/Auth';
import CreateOrder from './pages_android/CreateOrder';
import Referals from './pages_android/Referals';
import Statistics from './pages_android/Statistics';
import Aso from './pages_android/Aso';
import Pay from './pages_android/Pay';
import Agreement from './pages_android/Agreement';
import Policy from './pages_android/Policy';
import UniversalOrders from './pages_android/UniversalOrders';
import CreateUniversalOrder from './pages_android/CreateUniversalOrder';
import Reviews from './pages_android/Reviews';
import { getHttpParams } from './pages_android/custom_views/analyze_review/utils/Utils';
import Social from './pages_android/Social';
import CreateBotOrder from './pages_android/bot_orders/CreateBotOrder';
import BotOrders from './pages_android/bot_orders/BotOrders';
import BotOrderInfo from './pages_android/bot_orders/BotOrderInfo';

class Application extends React.Component {
   
    constructor(){
        super()
        this.state = {
            done : true,
            count_money_r : 0,
            email : "",
            first_name : "",
            _id : "",
            refList : [],
            badgeCount : 0,
            count_money_r_all_from_unitpay : 0,
            exchangeRate : 90.0

        }
        if (window.VK != undefined){
           // window.VK.Widgets.ContactUs("vk_contact_us", {disableExpandChatSound: "1",text: "Есть вопрос?", disableButtonTooltip: "1"}, 157374277)
            window.VK.Widgets.CommunityMessages("vk_community_messages", 157374277, {disableExpandChatSound: "1",tooltipButtonText: "Есть вопрос?",disableButtonTooltip: "1"})
        }
    }
    componentDidMount(){
        var token = getUrlParameter('token')
        if (token && token != ""){
            setToken(token)
            
        }
        this.getMyInfo()
        if ((getToken() == undefined || getToken() == "") && !window.location.href.includes("auth") && !window.location.href.includes("policy") && !window.location.href.includes("agreement")){
            window.location.href = '/auth'
        }
        this.getBadgeCount()
        this.getExchange()
    }
 
    getMyInfo = () => {
        this.setState({done : true})
        var params = getRequestParams()
        fetch(getRequestUrl() + "getMyInfo", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            if (responseData.customer){
                this.setState({count_money_r : responseData.customer.count_money_r, email : responseData.customer.email, first_name : responseData.customer.first_name, _id : responseData.customer._id, refList : responseData.customer.referal_earning_list_new.reverse(), count_money_r_all_from_unitpay : responseData.customer.count_money_r_all_from_unitpay})
            }
            if (responseData.customer.email != getEmail()){
                setCookieData(responseData.customer.email, responseData.customer.first_name)
            }
        })
    }
    getExchange = () => {
        var params = getRequestParams()
        fetch(getRequestUrl() + "getExchange", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            if (responseData.response == 1){
                this.setState({exchangeRate : responseData.rate})
            }
        })
    }
  
    updateMoney = (money) => {
        var countMoney = this.state.count_money_r + parseFloat(money)
        this.setState({count_money_r : countMoney})
    }
    setMoney = (money) => {
        this.setState({count_money_r : money})
    }
    onOrderCreate = () => {
        this.setState({isOrderCreate : true})
    }
    getBadgeCount = () => {
        var params = getRequestParams()
        fetch(getRequestUrl() + "getCountNeedCheckOrdersYoutube", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            if (responseData.response == 1){
                this.setState({badgeCount : responseData.count})
            }            
        })
    }
    removeBadge = () => {
        if (this.state.badgeCount > 0){
            this.setState({badgeCount : this.state.badgeCount - 1})
        }
    }
    
    render() {
        if (!this.state.done){
            return(
            <div>
                <Loader/>
            </div>) 
        } else return (
            <Router>
                <div className="app">
                    <aside className = "aside">
                        <Menu badgeCount={this.state.badgeCount} email={this.state.email}/>
                    </aside>
                    <div className = "main">
                    <Navbar exchangeRate={this.state.exchangeRate} first_name={this.state.first_name} email={this.state.email} count_money_r={this.state.count_money_r}/>
                        <section>
                            <main>
                                <Switch>
                                    <Route path="/orders">
                                        <Orders exchangeRate={this.state.exchangeRate} updateMoney={this.updateMoney} getMyInfo={this.getMyInfo} count_money_r={this.state.count_money_r} />
                                    </Route>

                                   
                                    <Route path="/auth">
                                        <Auth />
                                    </Route>
                                    <Route path="/neworder">
                                        <CreateOrder exchangeRate={this.state.exchangeRate}/>
                                    </Route>
                                    <Route path="/create_installs_order">
                                        <CreateBotOrder exchangeRate={this.state.exchangeRate}/>
                                    </Route>
                                    <Route path="/installs_orders">
                                        <BotOrders getMyInfo={this.getMyInfo} count_money_r={this.state.count_money_r} exchangeRate={this.state.exchangeRate}/>
                                    </Route>
                                    <Route path="/installs_order_info">
                                        <BotOrderInfo getMyInfo={this.getMyInfo} count_money_r={this.state.count_money_r} exchangeRate={this.state.exchangeRate}/>
                                    </Route>

                                    <Route path="/referals">
                                        <Referals exchangeRate={this.state.exchangeRate} refList={this.state.refList} _id={this.state._id} />
                                    </Route>
                                    <Route path="/statistics">
                                        <Statistics />
                                    </Route>

                                    <Route path="/seo">
                                        <Aso />
                                    </Route>
                                    <Route path="/pay">
                                        <Pay exchangeRate={this.state.exchangeRate} count_money_r={this.state.count_money_r}/>
                                    </Route>
                                    <Route path="/agreement">
                                        <Agreement />
                                    </Route>
                                    <Route path="/policy">
                                        <Policy />
                                    </Route>
                                    <Route path="/universal_orders">
                                        <UniversalOrders removeBadge={this.removeBadge} exchangeRate={this.state.exchangeRate} updateMoney={this.updateMoney} getMyInfo={this.getMyInfo} count_money_r={this.state.count_money_r} />
                                    </Route>
                                    <Route path="/create_universal">
                                        <CreateUniversalOrder count_money_r={this.state.count_money_r} count_money_r_all_from_unitpay={this.state.count_money_r_all_from_unitpay}/>
                                    </Route>
                                    <Route path="/social">
                                        <Social count_money_r={this.state.count_money_r} count_money_r_all_from_unitpay={this.state.count_money_r_all_from_unitpay}/>
                                    </Route>
                                    <Route path="/reviews">
                                        <Reviews email={this.state.email}/>
                                    </Route>
                                   
                                </Switch>
                            </main>
                        </section>
                    </div>
                    
                </div>
             </Router>
            
        );
    }
}

ReactDOM.render(

        <Application/>
   ,
    document.getElementById('root')
);
ReactDOM.render(
    !navigator.language.includes("en") ? "Продвижение мобильных приложений" : "Mobile apps promotion",
    document.getElementsByTagName("title")[0]
 );
window.onResume = () => {
    console.log("onResume index")
    if (window.photoTask != undefined){
        window.photoTask.onResume();
    }
   
   
}

